import { datetime, date } from "../../utils";
import I18n from "../../I18n";

const STATUS = {
    0: "IN_PROGRESS",
    1: "SUCCESS",
    2: "ERROR",
    3: "DELETED",
};
const mapCard = (json) => {
    const {
        message,
        userName,
        dateFrom,
        dateTo,
        fileType,
        createdAt,
        status,
        fileTypeName,
        fileLocation,
        id,
        fileName,
    } = json;

    return [
        [
            {
                labels: ["message"],
                value:
                    message !== "undefined"
                        ? message
                        : "The file couldn't be generated. Please contact the support.",
                align: "left",
            },
        ],
        [{ labels: ["user"], value: userName, align: "left" }],
        [
            {
                labels: ["date_from"],
                value: date(dateFrom),
                type: "date",
                align: "center",
            },
            {
                labels: ["date_to"],
                value: date(dateTo),
                type: "date",
                align: "center",
            },
        ],
        [
            {
                labels: ["file_type"],
                value: fileType ? fileType + " - " + (fileTypeName || "N/A") : "N/A",
                type: "string",
                align: "center",
            },
        ],
        [
            {
                labels: ["request_at"],
                value: datetime(createdAt),
                type: "datetime",
                align: "center",
            },
        ],
        [
            {
                labels: ["status"],
                value: [status, I18n.translate`${STATUS[status] || "submitted"}`, "center"],
                type: "fileStatus",
            },
        ],
        [
            {
                labels: ["download"],
                value: status === 1 ? [fileLocation, id] : null,
                type: "downloadFile",
            },
        ],
        [
            (STATUS[status] === "SUCCESS" || STATUS[status] === "ERROR")
                ? {
                      labels: ["hide_file"],
                      value: (STATUS[status] === "SUCCESS" || STATUS[status] === "ERROR") ? [fileLocation, fileName, `${id}`] : null,
                      type: "deleteFileByPath",
                      basis: "5%",
                  }
                : {
                      basis: "5%",
                      value: "",
                  },
        ],
    ];
};

const mapper = (json, card) => {
    return {
        ...json,
        id: json.id,
        name: json.name,
        shortName: json.name,
        card: card ? mapCard(json) : [],
    };
};

const header = [
    { label: ["Message"], align: "left", columnName: "message" },
    { label: ["User"], align: "left", mobileHidden: true },
    {
        label: ["date_from", "date_to"],
        mobileHidden: true,
        columnName: "uploaded_at",
        align: "center",
        boldColumn: true,
    },
    { label: ["file_type"], align: "center" },
    { label: ["requested_at"], mobileHidden: true, align: "center" },
    { label: ["status"], mobileHidden: true, align: "center" },
    { label: ["download"], align: "center", mobileHidden: true },
    { label: [""], align: "center", width: "actions-width" },
];

const generatordatafileMapper = {
    map: mapper,
    header,
};

export default generatordatafileMapper;
